import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

// type Props = {}

function MainLayout() {
  return (
    <>
      {/* <Topbar /> */}
      <div className="flex w-full flex-col">
        <div className="flex  bg-[#FCFCFC] w-full min-h-0">
          <div className="flex shrink-0">
            <Sidebar />
          </div>
          <div className="flex min-h-0 h-screen overflow-y-auto flex-1 flex-col overflow-hidden px-6 py-4">
            <Header />
            <div className="flex-1 overflow-y-auto">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MainLayout;
